import { Validator } from 'simple-vue-validator';

const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;

export const passwordValidator = function passwordValidator (value) {
  return Validator.value(value)
    .regex(PASSWORD_PATTERN, 'Password must be at least 8 characters long and contain both numbers and letters.')
    .required('Please enter password.');
};
